import React, { InputHTMLAttributes, MutableRefObject, useEffect, useRef } from 'react';
import {
  addKeyDownListener,
  KeyDownListenerParam,
  removeKeyDownListener,
} from '../QRScanner/GlobalScanner';

type Props = {
  onKeyDown: (param: KeyDownListenerParam) => void;
} & Omit<InputHTMLAttributes<HTMLInputElement>, 'onKeyDown'>;

const ScannerInput: React.ForwardRefExoticComponent<React.RefAttributes<HTMLInputElement> &
  Props> = React.forwardRef(({ value, onKeyDown, ...restProps }: Props, ref) => {
  const inputRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const key = addKeyDownListener({
      listener: param => {
        onKeyDown(param);
      },
      target: inputRef.current,
    });
    return () => {
      removeKeyDownListener(key);
    };
  }, [value, ref]);

  return (
    <input
      {...restProps}
      value={value}
      readOnly
      ref={node => {
        inputRef.current = node;
        if (typeof ref === 'function') {
          ref(node);
        } else if (ref) {
          (ref as MutableRefObject<HTMLDivElement>).current = node;
        }
      }}
      aria-valuetext={'scanner'}
    />
  );
});

export default ScannerInput;
